import React from 'react'
import { useTranslation } from 'react-i18next'
import numeral from 'numeral'
import { useSelector } from 'react-redux'

import styles from './styles.module.scss'

import ProfitIcon from '../../Icons/ProfitIcon'
import EditIcon from '../../Icons/EditIcon'
// import NoteIcon from '../../Icons/NoteIcon'

const NoteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 64 64">
      <path fill="#808f94" fill-rule="evenodd" d="M60 0H4C1.789 0 0 1.789 0 4v40c0 2.211 1.789 4 4 4h8v12a3.996 3.996 0 0 0 4 4 3.998 3.998 0 0 0 2.828-1.172L33.656 48H60c2.211 0 4-1.789 4-4V4c0-2.211-1.789-4-4-4z" clip-rule="evenodd">
      </path>
    </svg>
  )
}

const BonusCard = ({selectedItem, onEdit}) => {
  const { t } = useTranslation()
  const symbol = useSelector(state => state.company?.companyInfo?.currency_symbol)

  const handleEdit = () => {
    onEdit(selectedItem)
  }

  return (
    <div className={styles.commentCard}>
      <div className={styles.commentCard__header}>
        <ProfitIcon />
        { t('Bonus') }
        <div className={styles.editButton} onClick={handleEdit}>
          <EditIcon color={'#333945'} />
        </div>
      </div>
      <div className={styles.commentCard__body}>
        <div className={styles.commentCard__text}>
          { numeral(selectedItem.additional_bonus).format('0.00') }{ symbol }
        </div>
        {
          selectedItem.bonus_comment
            ? <div className={styles.bonusComment}>
                <div className={styles.bonusCommentHeader}>
                  <NoteIcon color={'#5D5E62'} />
                  <div className={styles.label}>{t(`Manager's comment`)}</div>
                </div>
                <div style={{paddingLeft: 20}}>
                  { selectedItem.bonus_comment }
                </div>
              </div>
            : null
        }
      </div>
    </div>
  );
}
export default BonusCard

